import React, { useContext, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import { useHistory } from "react-router-dom";
// import LanguageToggle from 'views/Forms/Private/LanguageToggle';
import {
  Button,
  Row,
  Col,
  FormGroup, FormControl, FormLabel
} from "react-bootstrap";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SweetAlert from "react-bootstrap-sweetalert";
import baolin_art2 from '../../../assets/img/baolinPrivate/baolin_art2.png';
import baolin_art3 from '../../../assets/img/baolinPrivate/baolin_art3.png';
import lianghuang from '../../../assets/img/baolinPrivate/lianghuang.png';
import vegefest from '../../../assets/img/baolinPrivate/vege_fest_poster.jpeg';
import qingming1 from '../../../assets/img/baolinPrivate/qingming1.png';
import { GuestContext } from "../../../contexts/GuestContext";

function SliderArrowNext(props) {
  const { className, onClick } = props;


  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  );
}

function SliderArrowPrev(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  );
}


export default function LivePreviewExample() {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const { language, setPageBanner } = useContext(GuestContext);
  useEffect(() => {
    setPageBanner(2);
  }, [setPageBanner]); // Dependencies array

  const handleRegisterClick = () => {
    history.push('/vegeregister');
  };

  const slide1 = (<>
    <div>
      <a
        href="#/"
        onClick={(e) => e.preventDefault()}
        className="card m-3 shadow-sm-dark card-box-hover-rise">
        <img src={vegefest} className="card-img-center" alt="..." />
        <div className="p-3 .bg-white-5 rounded-bottom p-xl-4">
          <div className="flex-column flex-sm-row justify-content-between block">
            <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between' }}>
              <h5 className="font-weight-bold font-size-lg text-second mb-0 ">
                {language === "Chinese" ? "宝林禅寺2025素食展" : "Bao Lin Vegefest 2025"}
              </h5>
              {/* <Badge
                className="text-white"
                style={{
                  fontSize: '0.9em',
                  background: 'linear-gradient(45deg, darkred, darkorange, darkgoldenrod, darkgreen, darkblue, indigo, purple)',
                  backgroundSize: '200% 200%',
                  animation: 'gradientShift 2s linear infinite',
                  transform: 'rotate(10deg)',
                }}
              >
                  {language === "Chinese" ? "免費活動" : "Free Activities"}
              </Badge> */}
            </div>

            <h6 className="font-weight-bold font-size-lg text-second mb-1 mt-1 block">
              {/* {language === "Chinese" ? "12月21日" : "21/12/2024"} */}
            </h6>
          </div>
          <div>
            <Badge className="mr-1 text-white block" color="info" style={{ fontSize: '0.9em' }}>
              <div dangerouslySetInnerHTML={{ __html: language === "Chinese" ? "日期： 2025年12月20日" : `Date: Dec 20<sup>th</sup> 2025` }} />

            </Badge>
          </div>
          <Badge className="mr-1 text-white block" color="success" style={{ fontSize: '0.9em' }}>
            {language === "Chinese" ? "時間：上午 11:30 ～ 下午 2:30" : "Time: 11:30AM ～ 02:30PM"}
          </Badge>

          <p className="text-second opacity-8 mt-4 mb-4">
            <p className="text-second opacity-8 mt-4 mb-4">
              <p className="text-second opacity-8 mt-4 mb-4">
                {language === "Chinese" ? (
                  <>
                    <p className='font-weight-bold mb-3'>
                    邀請您⼀同參與慈悲護⽣的素⻝饗宴、
                    還有親⼦遊戲、靜⼼活動等著您！

                    </p>
                  </>
                ) : (
                  <>
                    <p className='font-weight-bold mb-3'>

                    Hop onboard your journey to wisdom. 
Join us at Compassion Station to enjoy delicious vegetarian
 feast whilst practicing kindness and harmony.
 Enjoy fun carnival games, and mindfulness activities.

                    </p>
                  </>
                )}

              </p>

            </p>

          </p>

          <Row>
            <Col>
              <Button
                className="btn-round btn-wd mr-1 "
                style={{ fontWeight: 'bold' }}
                href="#/"
                type="button"
                variant="success"
                size="md"
                outline
                block
                onClick={handleRegisterClick}
              >
                {language === "Chinese" ? "我要報名" : "Register"}
              </Button>
            </Col>
          </Row>
        </div>
      </a>

    </div>
  </>)

  const slides = [slide1]

  const widgetsCarousels4A = {
    dots: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    infinite: slides.length >= 2,
    responsive: [
      {
        breakpoint: 1450,
        settings: { slidesToShow: 3, slidesToScroll: 1 }
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: 2, slidesToScroll: 1 }
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      }
    ]
  };


  return (
    <>
      {/* <Card className="bg-night-sky py-4"> */}
      <div className="py-0">
        <Slider
          className="rounded-lg overflow-hidden slider-arrows-outside slider-dots-outside slider-dots-light"
          {...widgetsCarousels4A}>
          {slides[0]}
        </Slider>
      </div>
      {/* </Card> */}
      {alert}
    </>
  );
}
